export const finderBoxShadow = '0px 10px 50px -12px rgba(0,0,0, 0.15)'
